mutation setDataUsageConsentForUser($type: String!, $consent: Boolean!, $encryptedEmail: String, $region: String!) {
    consents: setDataUsageConsentForUser(type: $type, consent: $consent, encryptedEmail: $encryptedEmail, region: $region) {
      objectId
      consent
      type
    }
  }